import Hero from "./components/hero/Hero";
import TopProjects from "./components/top_projects/TopProjects";
import About from "./components/about/About";
import Projects from "./components/projects/Projects";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <main>
      <Hero />
      <About />
      <TopProjects />
      <Projects />
      <Contact />
      <Footer />
      <ScrollToTop />
    </main>
  );
}

export default App;
